import { styled } from '@mui/material/styles';
import { InfoIcon } from '@phosphor-icons/react/Info';

export const StyledInfoIcon = styled(InfoIcon)`
  transform: translateY(${({ theme }) => theme.spacing(0.6)});
  color: ${({ theme }) => theme.palette.text.secondary};
  width: ${({ theme }) => theme.spacing(2.5)};
  height: ${({ theme }) => theme.spacing(2.5)};
  margin-left: ${({ theme }) => theme.spacing(0.5)};
`;
